import { useMemo } from 'react';

import { UseMainUIFeatureSettings } from '../types';

import {
  useDiscoverGroupsPageSettings,
  useInboxPageSettings,
  useLongFormContentSettings,
  useNavigationSettings,
} from './main';

export const useMainFeatureSettings: UseMainUIFeatureSettings = (...args) => {
  const discoverGroupsPage = useDiscoverGroupsPageSettings(...args);
  const inboxPage = useInboxPageSettings(...args);
  const longFormContent = useLongFormContentSettings(...args);
  const navigation = useNavigationSettings(...args);

  return useMemo(
    () => ({ discoverGroupsPage, inboxPage, longFormContent, navigation }),
    [discoverGroupsPage, inboxPage, longFormContent, navigation]
  );
};
